import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { wistiaTheme } from '~/singlePageApp/wistiaTheme';
import { VHSProvider } from '@wistia/vhs';
import { FeatureFlagProvider } from '~/singlePageApp/providers/FeatureFlagProvider';
import { createRoot } from 'react-dom/client';
import { WistiaApolloProvider } from '~/singlePageApp/providers/WistiaApolloProvider';
import { StyledComponentsCompatibilityProvider } from '~/singlePageApp/providers/StyledComponentsCompatibilityProvider';

const getComponentForImportPath = ({ importPath }) => {
  const modules = import.meta.glob('../**/*/railsEntryPointVite.ts');
  const key = Object.keys(modules).find((potentialKey) => {
    return potentialKey.match(importPath);
  });

  return lazyWithSuspense(() => modules[key]());
};

const Wrapper = ({ importPath, props }) => {
  const Component = getComponentForImportPath({ importPath });

  return (
    <WistiaApolloProvider>
      <StyledComponentsCompatibilityProvider>
        <FeatureFlagProvider skipIdentityLoading={props.skipIdentityLoading || false}>
          <VHSProvider
            theme={wistiaTheme}
            globalStylesIncluded={false}
          >
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Component {...props} />
          </VHSProvider>
        </FeatureFlagProvider>
      </StyledComponentsCompatibilityProvider>
    </WistiaApolloProvider>
  );
};

class HTMLReactComponentElement extends HTMLElement {
  connectedCallback() {
    this.root = createRoot(this);

    this.root.render(
      <Wrapper
        importPath={this.importPath}
        props={this.props}
      />,
    );
  }

  disconnectedCallback() {
    this.root.unmount();
  }

  get importPath() {
    return this.getAttribute('importPath');
  }

  get props() {
    return JSON.parse(this.getAttribute('props'));
  }
}

customElements.define('react-component', HTMLReactComponentElement);
